import type { ErrorCode, Usage } from '@lyrmo/shared';

/** Server error codes, plus failures that happen before a usable response arrives. */
export type ApiErrorCode = ErrorCode | 'NETWORK_ERROR' | 'INVALID_RESPONSE';

interface ApiErrorOptions extends ErrorOptions {
  readonly status?: number;
  readonly retryAfter?: number;
  readonly usage?: Usage;
}

export class ApiError extends Error {
  override readonly name = 'ApiError';
  readonly code: ApiErrorCode;
  readonly status: number | undefined;
  /** Seconds to wait before retrying, when the server said. */
  readonly retryAfter: number | undefined;
  /** Daily credit usage, sent with CREDIT_LIMIT_REACHED. */
  readonly usage: Usage | undefined;

  constructor(
    code: ApiErrorCode,
    message: string,
    { status, retryAfter, usage, ...options }: ApiErrorOptions = {},
  ) {
    super(message, options);
    this.code = code;
    this.status = status;
    this.retryAfter = retryAfter;
    this.usage = usage;
  }
}

/** The message to show for a failed request, or a generic one for unexpected errors. */
export const errorMessage = (error: unknown): string =>
  error instanceof ApiError ? error.message : 'Something went wrong. Please try again.';
